const androidProfile = 'talpa_chromecast_mp4_ovp_android';
const iosProfile = 'talpa_chromecast_mp4_ovp_ios';

const appPlayerChannel = 'kijk2 app';

export default function getAppConfiguration(
  adTagUrl: string = '',
  senderUserAgent: string = '',
): null | { playerChannel: string; platform: 'Android' | 'iOS' | 'unknown' } {
  if (!adTagUrl) {
    const platform = senderUserAgent.includes('Android')
      ? 'Android'
      : senderUserAgent.includes('iPhone') || senderUserAgent.includes('iPad')
        ? 'iOS'
        : 'unknown';

    return {
      playerChannel: appPlayerChannel,
      platform,
    };
  }

  if (adTagUrl.includes(androidProfile)) {
    return {
      playerChannel: appPlayerChannel,
      platform: 'Android',
    };
  }

  if (adTagUrl.includes(iosProfile)) {
    return {
      playerChannel: appPlayerChannel,
      platform: 'iOS',
    };
  }

  return null;
}
